export default __webpack_public_path__ + "static/media/Matt_bio.75803777.jpg";